import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import PropertyCopy from './PropertyCopy';
import { jsx as _jsx } from "react/jsx-runtime";
const ChickletFormattedProperty = ({
  copyDisabled,
  getAdditionalPropertyValue,
  objectId,
  objectTypeId,
  propertyDefinition,
  propertyFormatters = {},
  propertyName,
  propertyValue
}) => {
  const renderFormattedProperty = propertyFormatters[propertyName];
  if (renderFormattedProperty) {
    const formattedProperty = renderFormattedProperty(propertyDefinition);
    return formattedProperty || null;
  }
  const propertyLabel = propertyDefinition.hubspotDefined && propertyLabelTranslator(propertyDefinition.label) || propertyDefinition.label;
  const property = /*#__PURE__*/_jsx(FormattedPropertyV2, {
    objectTypeId: objectTypeId,
    objectId: objectId,
    value: propertyValue,
    getDraftValue: () => undefined,
    getSavedValue: getAdditionalPropertyValue,
    "data-selenium-test": `formatted-property-${propertyName}`,
    "data-test-id": `formatted-property-${propertyName}`
    // @ts-expect-error Known property issue as they have not updated the type definitions
    // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
    ,
    property: propertyDefinition
  });
  return /*#__PURE__*/_jsx(PropertyCopy, {
    data: property,
    propertyLabel: propertyLabel || undefined,
    propertyName: propertyName,
    isCopyDisabled: copyDisabled
  }, propertyName);
};
export default ChickletFormattedProperty;